var React = require('react');

function ArrowInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#630235","fillRule":"evenodd","transform":"rotate(-180 92.5 106)"},[React.createElement("rect",{"width":"150","height":"30","x":"-10.8","y":"49.2","rx":"15","transform":"rotate(-45 64.2 64.2)","key":0}),React.createElement("rect",{"width":"150","height":"30","x":"-10.8","y":"139.2","rx":"15","transform":"scale(1 -1) rotate(-45 -308.072 0)","key":1}),React.createElement("rect",{"width":"150","height":"30","x":"34.2","y":"94.2","rx":"15","key":2})]));
}

ArrowInline.defaultProps = {"width":"179","height":"206","viewBox":"0 0 179 206"};

module.exports = ArrowInline;

ArrowInline.default = ArrowInline;
